var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 349,
    height: 93,
    viewBox: "0 0 349 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M313.055 68.72H318.334V0.0493164H313.055V68.72Z",
    fill: "#245864"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M349 0.00195312H313.055V5.32927H349V0.00195312Z",
    fill: "#245864"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M349 63.3921H313.055V68.7194H349V63.3921Z",
    fill: "#245864"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M349 31.6479H313.055V36.9753H349V31.6479Z",
    fill: "#245864"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.946 68.7195H310.225V0.0488281H304.946V68.7195Z",
    fill: "#245864"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M274.281 68.7195H279.56V0.0488281H274.281V68.7195Z",
    fill: "#245864"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M310.224 31.647H274.571V36.9743H310.224V31.647Z",
    fill: "#245864"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M248.996 68.8996C242.234 68.8996 235.887 66.4354 231.569 62.1308C227.765 58.3377 225.756 53.3616 225.756 47.7364C225.756 43.7887 227.076 39.7089 229.476 36.2501C232.1 32.4653 235.887 29.5432 240.433 27.8011L242.324 32.7322C236.705 34.8845 231.038 40.3608 231.038 47.7392C231.038 51.9286 232.513 55.615 235.3 58.3939C238.635 61.7178 243.624 63.6228 248.999 63.6228C249.021 63.6228 249.041 63.6228 249.064 63.6228C253.556 63.6116 257.745 61.9454 260.855 58.9361C263.999 55.896 265.73 51.7431 265.73 47.2419C265.73 41.0407 261.479 35.6066 254.357 32.6985C252.266 31.8444 250.342 31.1475 248.479 30.476C244.431 29.0093 240.933 27.7449 238.371 25.6938C235.35 23.2746 233.917 20.0602 233.861 15.573C233.808 11.3246 235.311 7.43309 238.095 4.6149C240.955 1.70679 244.928 0.11084 249.274 0.11084C253.323 0.11084 257.147 1.66745 260.043 4.49408C262.934 7.31508 264.586 11.0914 264.69 15.1234L259.414 15.2639C259.344 12.6115 258.259 10.1277 256.357 8.27322C254.452 6.41315 251.938 5.39039 249.274 5.39039C246.35 5.39039 243.711 6.43001 241.843 8.32098C240.034 10.153 239.095 12.6368 239.132 15.5027C239.205 21.2319 241.866 22.4682 250.269 25.5111C252.089 26.1714 254.154 26.9188 256.343 27.8123C260.507 29.5123 264.055 32.0607 266.606 35.1824C269.48 38.7002 271 42.8727 271 47.2447C271 59.3576 261.369 68.8715 249.072 68.9052H248.993L248.996 68.8996Z",
    fill: "#245864"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M225.756 85.1623C225.756 80.692 229.158 77.3989 233.757 77.3989C235.982 77.3989 237.988 78.1407 239.34 79.6243L238.314 80.6498C237.073 79.3854 235.544 78.8403 233.799 78.8403C230.113 78.8403 227.346 81.5433 227.346 85.1651C227.346 88.7869 230.116 91.4899 233.799 91.4899C235.544 91.4899 237.07 90.9448 238.314 89.6579L239.34 90.6835C237.988 92.1671 235.982 92.9285 233.735 92.9285C229.158 92.9257 225.756 89.6327 225.756 85.1623Z",
    fill: "#245864"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M241.109 85.1623C241.109 80.7145 244.512 77.3989 249.133 77.3989C253.755 77.3989 257.135 80.692 257.135 85.1623C257.135 89.6327 253.71 92.9257 249.133 92.9257C244.557 92.9257 241.109 89.6102 241.109 85.1623ZM255.522 85.1623C255.522 81.5209 252.797 78.8375 249.133 78.8375C245.47 78.8375 242.7 81.5209 242.7 85.1623C242.7 88.8038 245.447 91.4871 249.133 91.4871C252.819 91.4871 255.522 88.8038 255.522 85.1623Z",
    fill: "#245864"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M273.511 77.5283V92.7938H272.182L262.369 80.4083V92.7938H260.756V77.5283H262.085L271.918 89.9138V77.5283H273.511Z",
    fill: "#245864"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M289.232 85.1623H290.78V90.9842C289.342 92.271 287.291 92.9257 285.175 92.9257C280.531 92.9257 277.129 89.6327 277.129 85.1623C277.129 80.692 280.531 77.3989 285.198 77.3989C287.51 77.3989 289.516 78.1407 290.867 79.6018L289.864 80.6273C288.578 79.363 287.052 78.8403 285.262 78.8403C281.489 78.8403 278.722 81.5237 278.722 85.1651C278.722 88.8066 281.492 91.4899 285.243 91.4899C286.704 91.4899 288.055 91.164 289.232 90.3126V85.1651V85.1623Z",
    fill: "#245864"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M305.763 92.7938L302.274 87.8879C301.88 87.9301 301.49 87.9526 301.052 87.9526H296.953V92.7938H295.34V77.5283H301.052C304.932 77.5283 307.289 79.4923 307.289 82.7629C307.289 85.1625 306.024 86.8399 303.799 87.5592L307.528 92.7938H305.76H305.763ZM305.676 82.7629C305.676 80.3212 304.063 78.9248 301.009 78.9248H296.953V86.5786H301.009C304.063 86.5786 305.676 85.1625 305.676 82.7629Z",
    fill: "#245864"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M321.9 91.3973V92.7938H311.105V77.5283H321.571V78.9248H312.718V84.3532H320.613V85.7272H312.718V91.3973H321.897H321.9Z",
    fill: "#245864"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M324.233 90.9393L324.865 89.6974C325.956 90.7651 327.897 91.5519 329.903 91.5519C332.76 91.5519 334.002 90.3521 334.002 88.8489C334.002 84.6623 324.604 87.236 324.604 81.5884C324.604 79.3434 326.349 77.4019 330.229 77.4019C331.951 77.4019 333.741 77.902 334.96 78.7534L334.415 80.0402C333.106 79.1889 331.58 78.7758 330.229 78.7758C327.439 78.7758 326.194 80.0177 326.194 81.5463C326.194 85.7328 335.592 83.204 335.592 88.7646C335.592 91.0096 333.805 92.9286 329.9 92.9286C327.61 92.9286 325.366 92.1222 324.23 90.9449L324.233 90.9393Z",
    fill: "#245864"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M337.639 90.9393L338.271 89.6974C339.361 90.7651 341.302 91.5519 343.308 91.5519C346.165 91.5519 347.407 90.3521 347.407 88.8489C347.407 84.6623 338.009 87.236 338.009 81.5884C338.009 79.3434 339.754 77.4019 343.634 77.4019C345.356 77.4019 347.146 77.902 348.365 78.7534L347.82 80.0402C346.511 79.1889 344.985 78.7758 343.634 78.7758C340.844 78.7758 339.6 80.0177 339.6 81.5463C339.6 85.7328 348.997 83.204 348.997 88.7646C348.997 91.0096 347.211 92.9286 343.305 92.9286C341.016 92.9286 338.771 92.1222 337.636 90.9449L337.639 90.9393Z",
    fill: "#245864"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.075 71.4642L171.214 71.4642L171.214 64.332L164.075 64.332L164.075 71.4642Z",
    fill: "#245864"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.935 78.5979L164.074 78.5979L164.074 71.4658L156.935 71.4658L156.935 78.5979Z",
    fill: "#95C8BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M164.076 85.7298L171.204 85.7298L171.204 78.5977L164.076 78.5977L164.076 85.7298Z",
    fill: "#245864"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M171.203 78.5979L178.342 78.5979L178.342 71.4658L171.203 71.4658L171.203 78.5979Z",
    fill: "#FCE784"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.203 92.9275L178.342 92.9275L178.342 85.7319L171.203 85.7319L171.203 92.9275Z",
    fill: "#95C8BF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M185.462 7.24883L192.602 7.24883L192.602 0.116699L185.462 0.116699L185.462 7.24883Z",
    fill: "#95C8BF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M171.198 35.7921L171.198 28.5986L178.337 28.5986L178.337 35.7921",
    fill: "#245864"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M185.462 50.0657L192.595 50.0657L192.595 42.9336L185.462 42.9336L185.462 50.0657Z",
    fill: "#245864"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M178.337 14.3836L185.477 14.3836L185.477 7.25146L178.337 7.25146L178.337 14.3836Z",
    fill: "#245864"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 14.3836L206.864 14.3836L206.864 7.25146L199.731 7.25146L199.731 14.3836Z",
    fill: "#245864"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 21.4217L206.864 21.4217L206.864 14.2896L199.731 14.2896L199.731 21.4217Z",
    fill: "#245864"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 35.7986L206.864 35.7986L206.864 28.5967L199.731 28.5967L199.731 35.7986Z",
    fill: "#245864"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M199.731 50.1355L206.864 50.1355L206.864 42.9336L199.731 42.9336L199.731 50.1355Z",
    fill: "#245864"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M2.01922e-05 92.8958L7.13281 92.8958L7.13281 85.7637L2.0504e-05 85.7637L2.01922e-05 92.8958Z",
    fill: "#F5D858"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M192.6 14.3836L199.739 14.3836L199.739 7.25146L192.6 7.25146L192.6 14.3836Z",
    fill: "#B43125"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M192.602 57.1971L199.734 57.1971L199.734 50.0649L192.602 50.0649L192.602 57.1971Z",
    fill: "#B43125"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M192.595 71.4642L199.734 71.4642L199.734 64.332L192.595 64.332L192.595 71.4642Z",
    fill: "#245864"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M215.043 21.5219L222.182 21.5219L222.182 14.3813L215.043 14.3813L215.043 21.5219Z",
    fill: "#203A60"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M206.864 28.5993L213.997 28.5993L213.997 21.5391L206.864 21.5391L206.864 28.5993Z",
    fill: "#F5D858"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M206.864 7.21351L213.997 7.21351L213.997 0.15332L206.864 0.15332L206.864 7.21351Z",
    fill: "#F5D858"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M206.864 71.4642L213.997 71.4642L213.997 64.332L206.864 64.332L206.864 71.4642Z",
    fill: "#B43125"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M178.333 42.9336L171.2 42.9336L171.2 50.0657L178.333 50.0657L178.333 42.9336Z",
    fill: "#245864"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M156.935 92.9275L164.074 92.9275L164.074 85.7319L156.935 85.7319L156.935 92.9275Z",
    fill: "#245864"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M199.951 92.9275L207.09 92.9275L207.09 85.7319L199.951 85.7319L199.951 92.9275Z",
    fill: "#245864"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 92.8641L149.806 92.8641L149.806 85.7319L142.667 85.7319L142.667 92.8641Z",
    fill: "#95C8BF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M149.807 85.7298L156.939 85.7298L156.939 78.5977L149.807 78.5977L149.807 85.7298Z",
    fill: "#245864"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M135.538 85.7298L142.677 85.7298L142.677 78.5977L135.538 78.5977L135.538 85.7298Z",
    fill: "#245864"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M128.408 85.7298L135.547 85.7298L135.547 78.5977L128.408 78.5977L128.408 85.7298Z",
    fill: "#245864"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M128.408 92.8641L135.547 92.8641L135.547 85.7319L128.408 85.7319L128.408 92.8641Z",
    fill: "#F5D858"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 85.7298L128.403 85.7298L128.403 78.5977L121.264 78.5977L121.264 85.7298Z",
    fill: "#B43125"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M149.805 71.4642L156.944 71.4642L156.944 64.332L149.805 64.332L149.805 71.4642Z",
    fill: "#486D97"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M156.935 64.3312L164.074 64.3312L164.074 57.2266L156.935 57.2266L156.935 64.3312Z",
    fill: "#245864"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M164.075 57.1971L171.214 57.1971L171.214 50.0649L164.075 50.0649L164.075 57.1971Z",
    fill: "#486D97"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M178.329 42.9334L185.468 42.9334L185.468 35.8013L178.329 35.8013L178.329 42.9334Z",
    fill: "#95C8BF"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M206.869 42.9329L214.008 42.9329L214.008 35.8008L206.869 35.8008L206.869 42.9329Z",
    fill: "#95C8BF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M156.939 50.0657L164.074 50.0657L164.074 42.9336L156.939 42.9336L156.939 50.0657Z",
    fill: "#245864"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M164.076 50.0657L171.209 50.0657L171.209 42.9336L164.076 42.9336L164.076 50.0657Z",
    fill: "#95C8BF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M164.076 42.9334L171.209 42.9334L171.209 35.8013L164.076 35.8013L164.076 42.9334Z",
    fill: "#FCE784"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M156.941 35.7991L164.074 35.7991L164.074 28.6035L156.941 28.6035L156.941 35.7991Z",
    fill: "#B43125"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M149.807 42.9334L156.944 42.9334L156.944 35.8013L149.807 35.8013L149.807 42.9334Z",
    fill: "#245864"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M149.8 57.1971L156.939 57.1971L156.939 50.0649L149.8 50.0649L149.8 57.1971Z",
    fill: "#245864"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M142.663 64.3318L149.802 64.3318L149.802 57.1997L142.663 57.1997L142.663 64.3318Z",
    fill: "#245864"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M135.538 64.3318L142.656 64.3318L142.656 57.1997L135.538 57.1997L135.538 64.3318Z",
    fill: "#245864"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M135.528 71.4642L142.667 71.4642L142.667 64.332L135.528 64.332L135.528 71.4642Z",
    fill: "#245864"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M128.404 71.4642L135.526 71.4642L135.526 64.332L128.404 64.332L128.404 71.4642Z",
    fill: "#245864"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 71.4642L128.403 71.4642L128.403 64.332L121.264 64.332L121.264 71.4642Z",
    fill: "#95C8BF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 64.3318L128.403 64.3318L128.403 57.1997L121.264 57.1997L121.264 64.3318Z",
    fill: "#245864"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M114.125 64.3318L121.264 64.3318L121.264 57.1997L114.125 57.1997L114.125 64.3318Z",
    fill: "#F5D858"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M142.663 57.1971L149.802 57.1971L149.802 50.0649L142.663 50.0649L142.663 57.1971Z",
    fill: "#B43125"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M149.807 50.0657L156.939 50.0657L156.939 42.9336L149.807 42.9336L149.807 50.0657Z",
    fill: "#95C8BF"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 42.9334L149.806 42.9334L149.806 35.8013L142.667 35.8013L142.667 42.9334Z",
    fill: "#245864"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 35.7991L149.806 35.7991L149.806 28.6035L142.667 28.6035L142.667 35.7991Z",
    fill: "#95C8BF"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M135.538 35.7991L142.677 35.7991L142.677 28.6035L135.538 28.6035L135.538 35.7991Z",
    fill: "#245864"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M135.538 28.595L142.677 28.595L142.677 21.5391L135.538 21.5391L135.538 28.595Z",
    fill: "#245864"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M128.408 28.5993L135.547 28.5993L135.547 21.5391L128.408 21.5391L128.408 28.5993Z",
    fill: "#245864"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 28.5993L128.403 28.5993L128.403 21.5391L121.264 21.5391L121.264 28.5993Z",
    fill: "#B43125"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8731 28.6671L107.006 28.6671L107.006 21.5371L99.8731 21.5371L99.8731 28.6671Z",
    fill: "#245864"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8731 7.13001L107.006 7.13001L107.006 0L99.8731 -3.11784e-07L99.8731 7.13001Z",
    fill: "#245864"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3369 28.6673L78.4697 28.6673L78.4697 21.5415L71.3369 21.5415L71.3369 28.6673Z",
    fill: "#245864"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7339 35.7991L99.873 35.7991L99.873 28.667L92.7339 28.667L92.7339 35.7991Z",
    fill: "#B43125"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5992 35.7991L92.7383 35.7991L92.7383 28.667L85.5992 28.667L85.5992 35.7991Z",
    fill: "#245864"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4703 35.7991L85.6094 35.7991L85.6094 28.667L78.4703 28.667L78.4703 35.7991Z",
    fill: "#486D97"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4703 28.6673L85.6094 28.6673L85.6094 21.5415L78.4703 21.5415L78.4703 28.6673Z",
    fill: "#245864"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4707 21.5387L85.6035 21.5387L85.6035 14.3833L78.4707 14.3833L78.4707 21.5387Z",
    fill: "#95C8BF"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5997 21.5366L92.7324 21.5366L92.7324 14.3833L85.5997 14.3833L85.5997 21.5366Z",
    fill: "#B43125"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5992 42.9334L92.7383 42.9334L92.7383 35.8013L85.5992 35.8013L85.5992 42.9334Z",
    fill: "#245864"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3306 50.0657L78.4697 50.0657L78.4697 42.9336L71.3306 42.9336L71.3306 50.0657Z",
    fill: "#245864"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2027 57.1971L71.3418 57.1971L71.3418 50.0649L64.2027 50.0649L64.2027 57.1971Z",
    fill: "#95C8BF"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2022 42.9334L71.335 42.9334L71.335 35.8013L64.2022 35.8013L64.2022 42.9334Z",
    fill: "#245864"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0684 64.3318L64.2012 64.3318L64.2012 57.1997L57.0684 57.1997L57.0684 64.3318Z",
    fill: "#B43125"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9331 57.1971L57.0723 57.1971L57.0723 50.0649L49.9331 50.0649L49.9331 57.1971Z",
    fill: "#245864"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7935 50.0657L49.9326 50.0657L49.9326 42.9336L42.7935 42.9336L42.7935 50.0657Z",
    fill: "#245864"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 50.0657L64.2012 50.0657L64.2012 42.9336L57.0621 42.9336L57.0621 50.0657Z",
    fill: "#245864"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 35.7991L64.2012 35.7991L64.2012 28.6035L57.0621 28.6035L57.0621 35.7991Z",
    fill: "#245864"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9331 42.9334L57.0723 42.9334L57.0723 35.8013L49.9331 35.8013L49.9331 42.9334Z",
    fill: "#245864"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7403 28.6671L99.873 28.6671L99.873 21.5435L92.7403 21.5435L92.7403 28.6671Z",
    fill: "#245864"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7403 21.5366L99.873 21.5366L99.873 14.3833L92.7403 14.3833L92.7403 21.5366Z",
    fill: "#203A60"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8619 71.4642L107.001 71.4642L107.001 64.332L99.8619 64.332L99.8619 71.4642Z",
    fill: "#245864"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3306 71.4642L78.4697 71.4642L78.4697 64.332L71.3306 64.332L71.3306 71.4642Z",
    fill: "#B43125"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7551 78.5979L99.873 78.5979L99.873 71.4658L92.7551 71.4658L92.7551 78.5979Z",
    fill: "#245864"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6089 78.5979L92.748 78.5979L92.748 71.4658L85.6089 71.4658L85.6089 78.5979Z",
    fill: "#245864"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4703 78.5979L85.6094 78.5979L85.6094 71.4658L78.4703 71.4658L78.4703 78.5979Z",
    fill: "#F5D858"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 21.5387L64.2012 21.5387L64.2012 14.3833L57.0621 14.3833L57.0621 21.5387Z",
    fill: "#245864"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1958 14.3836L71.335 14.3836L71.335 7.25146L64.1958 7.25146L64.1958 14.3836Z",
    fill: "#245864"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9339 14.3836L57.0625 14.3836L57.0625 7.25146L49.9339 7.25146L49.9339 14.3836Z",
    fill: "#95C8BF"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 7.24883L64.2012 7.24883L64.2012 0.116699L57.0621 0.116699L57.0621 7.24883Z",
    fill: "#245864"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8257 7.24883L28.9648 7.24883L28.9648 0.116699L21.8257 0.116699L21.8257 7.24883Z",
    fill: "#245864"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8257 92.8958L28.9648 92.8958L28.9648 85.7637L21.8257 85.7637L21.8257 92.8958Z",
    fill: "#245864"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M71.3306 7.24883L78.4697 7.24883L78.4697 0.116699L71.3306 0.116699L71.3306 7.24883Z",
    fill: "#245864"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7935 7.24883L49.9326 7.24883L49.9326 0.116699L42.7935 0.116699L42.7935 7.24883Z",
    fill: "#FCE784"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0904 50.1707L28.2295 50.1707L28.2295 42.9751L21.0904 42.9751L21.0904 50.1707Z",
    fill: "#95C8BF"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2647 71.4642L21.3975 71.4642L21.3975 64.332L14.2647 64.332L14.2647 71.4642Z",
    fill: "#245864"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M14.26 28.5991L21.4033 28.5991L21.4033 21.5347L14.26 21.5347L14.26 28.5991Z",
    fill: "#245864"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0571553 42.9334L7.13281 42.9334L7.13281 35.8013L0.0571556 35.8013L0.0571553 42.9334Z",
    fill: "#B43125"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6646 21.5366L42.8037 21.5366L42.8037 14.3833L35.6646 14.3833L35.6646 21.5366Z",
    fill: "#B43125"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6661 28.6673L42.7988 28.6673L42.7988 21.5415L35.6661 21.5415L35.6661 28.6673Z",
    fill: "#245864"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6646 35.7991L42.8037 35.7991L42.8037 28.667L35.6646 28.667L35.6646 35.7991Z",
    fill: "#245864"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8033 28.6673L49.9424 28.6673L49.9424 21.5415L42.8033 21.5415L42.8033 28.6673Z",
    fill: "#245864"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5259 28.5994L35.665 28.5994L35.665 21.5371L28.5259 21.5371L28.5259 28.5994Z",
    fill: "#95C8BF"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6661 64.3318L42.7988 64.3318L42.7988 57.1997L35.6661 57.1997L35.6661 64.3318Z",
    fill: "#245864"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6661 71.4651L42.7988 71.4651L42.7988 64.333L35.6661 64.333L35.6661 71.4651Z",
    fill: "#245864"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6646 78.5979L42.8037 78.5979L42.8037 71.4658L35.6646 71.4658L35.6646 78.5979Z",
    fill: "#245864"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8041 71.4642L49.9326 71.4642L49.9326 64.332L42.8041 64.332L42.8041 71.4642Z",
    fill: "#245864"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5308 71.4663L35.6699 71.4663L35.6699 64.332L28.5308 64.332L28.5308 71.4663Z",
    fill: "#203A60"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M57.066 78.5979L64.2051 78.5979L64.2051 71.4658L57.066 71.4658L57.066 78.5979Z",
    fill: "#95C8BF"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0621 92.8641L64.2012 92.8641L64.2012 85.7319L57.0621 85.7319L57.0621 92.8641Z",
    fill: "#245864"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M107.252 92.8641L114.391 92.8641L114.391 85.7319L107.252 85.7319L107.252 92.8641Z",
    fill: "#245864"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4703 71.4642L85.6094 71.4642L85.6094 64.332L78.4703 64.332L78.4703 71.4642Z",
    fill: "#245864"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4701 64.3318L85.5986 64.3318L85.5986 57.1997L78.4701 57.1997L78.4701 64.3318Z",
    fill: "#245864"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5992 64.3318L92.7383 64.3318L92.7383 57.1997L85.5992 57.1997L85.5992 64.3318Z",
    fill: "#95C8BF"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5992 57.1971L92.7383 57.1971L92.7383 50.0649L85.5992 50.0649L85.5992 57.1971Z",
    fill: "#245864"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7378 71.4954L99.877 71.4954L99.877 64.2998L92.7378 64.2998L92.7378 71.4954Z",
    fill: "#486D97"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7378 64.3953L99.877 64.3953L99.877 57.1997L92.7378 57.1997L92.7378 64.3953Z",
    fill: "#245864"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 35.7985L128.403 35.7985L128.403 28.5986L121.264 28.5986L121.264 35.7985Z",
    fill: "#95C8BF"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M114.135 35.7985L121.264 35.7985L121.264 28.5986L114.135 28.5986L114.135 35.7985Z",
    fill: "#245864"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M114.139 42.9329L121.278 42.9329L121.278 35.8008L114.139 35.8008L114.139 42.9329Z",
    fill: "#245864"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M107.002 42.9334L114.141 42.9334L114.141 35.8013L107.002 35.8013L107.002 42.9334Z",
    fill: "#245864"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M107.002 50.0657L114.141 50.0657L114.141 42.9336L107.002 42.9336L107.002 50.0657Z",
    fill: "#245864"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8731 50.0657L107.006 50.0657L107.006 42.9336L99.8731 42.9336L99.8731 50.0657Z",
    fill: "#FCE784"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M114.125 57.1971L121.264 57.1971L121.264 50.0649L114.125 50.0649L114.125 57.1971Z",
    fill: "#95C8BF"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M107.003 57.1971L114.121 57.1971L114.121 50.0649L107.003 50.0649L107.003 57.1971Z",
    fill: "#245864"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M149.8 28.595L156.939 28.595L156.939 21.5391L149.8 21.5391L149.8 28.595Z",
    fill: "#245864"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 21.5387L128.403 21.5387L128.403 14.3833L121.264 14.3833L121.264 21.5387Z",
    fill: "#245864"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M114.13 21.5493L121.27 21.5493L121.27 14.3833L114.13 14.3833L114.13 21.5493Z",
    fill: "#245864"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M135.538 78.5979L142.667 78.5979L142.667 71.4658L135.538 71.4658L135.538 78.5979Z",
    fill: "#245864"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 78.5979L128.403 78.5979L128.403 71.4658L121.264 71.4658L121.264 78.5979Z",
    fill: "#203A60"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M114.13 78.5979L121.27 78.5979L121.27 71.4658L114.13 71.4658L114.13 78.5979Z",
    fill: "#245864"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M128.398 50.0657L135.537 50.0657L135.537 42.9336L128.398 42.9336L128.398 50.0657Z",
    fill: "#245864"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M171.194 64.3318L178.333 64.3318L178.333 57.1997L171.194 57.1997L171.194 64.3318Z",
    fill: "#95C8BF"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M178.333 71.4642L185.472 71.4642L185.472 64.332L178.333 64.332L178.333 71.4642Z",
    fill: "#245864"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M185.496 78.5979L192.602 78.5979L192.602 71.4658L185.496 71.4658L185.496 78.5979Z",
    fill: "#203A60"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M178.333 57.1971L185.472 57.1971L185.472 50.0649L178.333 50.0649L178.333 57.1971Z",
    fill: "#245864"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5997 14.3836L92.7324 14.3836L92.7324 7.25146L85.5997 7.25146L85.5997 14.3836Z",
    fill: "#F5D858"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6089 85.7298L92.748 85.7298L92.748 78.5977L85.6089 78.5977L85.6089 85.7298Z",
    fill: "#95C8BF"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 78.5979L149.806 78.5979L149.806 71.4658L142.667 71.4658L142.667 78.5979Z",
    fill: "#203A60"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M142.673 21.5387L149.806 21.5387L149.806 14.3833L142.673 14.3833L142.673 21.5387Z",
    fill: "#245864"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M135.539 21.5387L142.672 21.5387L142.672 14.3833L135.539 14.3833L135.539 21.5387Z",
    fill: "#203A60"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M135.539 14.3836L142.672 14.3836L142.672 7.25146L135.539 7.25146L135.539 14.3836Z",
    fill: "#245864"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M128.404 14.3836L135.537 14.3836L135.537 7.25146L128.404 7.25146L128.404 14.3836Z",
    fill: "#245864"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M128.404 7.25094L135.537 7.25094L135.537 0.116699L128.404 0.116699L128.404 7.24883L128.404 7.25094Z",
    fill: "#245864"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M121.264 14.3836L128.403 14.3836L128.403 7.25146L121.264 7.25146L121.264 14.3836Z",
    fill: "#95C8BF"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M164.108 28.5993L171.209 28.5993L171.209 21.5391L164.108 21.5391L164.108 28.5993Z",
    fill: "#245864"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M156.941 21.5389L164.069 21.5389L164.069 14.3813L156.941 14.3813L156.941 21.5389Z",
    fill: "#95C8BF"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M149.805 14.3836L156.939 14.3836L156.939 7.25146L149.805 7.25146L149.805 14.3836Z",
    fill: "#245864"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M178.327 14.3833L171.199 14.3833L171.199 21.5387L178.327 21.5387L178.327 14.3833Z",
    fill: "#B43125"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M171.2 28.5993L178.333 28.5993L178.333 21.5391L171.2 21.5391L171.2 28.5993Z",
    fill: "#F5D858"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M185.468 21.5391L178.329 21.5391L178.329 28.5993L185.468 28.5993L185.468 21.5391Z",
    fill: "#245864"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M185.466 35.7942L192.605 35.7942L192.605 28.5986L185.466 28.5986L185.466 35.7942Z",
    fill: "#245864"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M164.077 14.3838L171.214 14.3838L171.214 7.24951L164.077 7.24951L164.077 14.3838Z",
    fill: "#245864"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M156.94 7.24883L164.079 7.24883L164.079 0.116699L156.94 0.116699L156.94 7.24883Z",
    fill: "#245864"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M164.076 7.24883L171.209 7.24883L171.209 0.116699L164.076 0.116699L164.076 7.24883Z",
    fill: "#245864"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M142.667 7.24883L149.806 7.24883L149.806 0.116699L142.667 0.116699L142.667 7.24883Z",
    fill: "#B43125"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShe);
export default __webpack_public_path__ + "static/media/she.e1e11f1fd0d2d2bc4bd9115a85635c7b.svg";
export { ForwardRef as ReactComponent };